import type { StandardBehaviorOptions } from 'scroll-into-view-if-needed';

export function scrollIntoView(target: HTMLElement, options: StandardBehaviorOptions = {}) {
	import('scroll-into-view-if-needed').then(({ default: scrollIntoView }) => {
		scrollIntoView(target, {
			behavior: 'smooth',
			scrollMode: 'if-needed',
			...options,
		});
	});
}
